import { useEffect, useRef } from "react";
import { useKeyPress } from "./useKeyPress";

export const useEnter = (callback: any, disabled?: boolean) => {
  const enter = useKeyPress("Enter");

  const clickedRef = useRef<any>(false);

  useEffect(() => {
    if (!clickedRef.current && enter && callback && !disabled) {
      clickedRef.current = true;
      callback();
    }

    if (!enter && !disabled) {
      clickedRef.current = false;
    }
  }, [enter, callback, disabled]);
};
